(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HeightUpdater", [], factory);
	else if(typeof exports === 'object')
		exports["HeightUpdater"] = factory();
	else
		root["HeightUpdater"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 